import { useMemo } from 'react'

const EMPTY_ARRAY = []

export default function useAlertEvents( props ) {
  const { result } = props

  return useMemo( () => {
    if ( !result.items ) {
      return {
        result : {
          counts : {}
        }
      }
    }

    const counts = result.items.reduce( ( acc, curr ) => {
      const type = curr.type
      const cause = curr?.data?.cause ?? curr?.data?.subtype

      return {
        ...acc,
        perType : { ...acc?.perType, [type] : ( acc?.perType?.[type] ?? 0 ) + 1 },
        perCause : { ...acc?.perCause, [cause] : ( acc?.perCause?.[cause] ?? 0 ) + 1 },
      }
    }, {} )

    return {
      result : {
        // ...props.result,local
        items : result?.items || EMPTY_ARRAY,
        counts
      },
    }
  }, [ result?.items ] )
}
